import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const heroBgImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/086fde9a-921e-4fc8-82b8-df597b7252a8_compressed_ChatGPT-Image-13-ago-2026-05_44_01-p.m.-4.webp';

export default function ConoceAMercedes() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[580px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroBgImage}
            alt={t('mercedes.tag')}
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" />
        </div>
        <div className="relative z-10 min-h-[500px] md:min-h-[580px] flex items-center">
          <div className="w-full px-6 md:px-10 lg:px-16">
            <div className="max-w-xl ml-20">
              <span className="inline-block font-sans text-xs font-semibold text-white uppercase tracking-[0.2em] bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full">
                {t('mercedes.tag')}
              </span>
              <h1 className="font-serif text-[clamp(2rem,4vw,3.5rem)] font-bold text-white leading-[1.1] mt-2">
                {t('mercedes.hero_title1')}{' '}
                <span className="text-terracotta">{t('mercedes.hero_title2')}</span>
              </h1>
              <p className="font-serif text-base md:text-lg italic text-white leading-tight mt-1">
                {t('mercedes.hero_sub')}
              </p>
              <p className="font-sans text-sm md:text-base text-white/90 leading-tight max-w-lg mt-1">
                {t('mercedes.hero_desc')} {t('mercedes.hero_desc2')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#4A3428] leading-tight mb-3">
              {t('mercedes.video_title')}
            </h2>
          </div>

          {/* Video — marco 16:9 completo, sin recorte */}
          <div className="relative w-full aspect-video bg-black rounded-2xl overflow-hidden">
            <iframe
              src="https://www.youtube.com/embed/BAtiFKvgAc4"
              title={t('mercedes.video_title')}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              className="absolute inset-0 w-full h-full border-0"
            />
          </div>
        </div>
      </section>

      {/* Historia Section */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-sand">
        <div className="max-w-5xl mx-auto">
          {/* Título */}
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#4A3428] leading-tight mb-4 text-center">
            {t('mercedes.bio_title')}
          </h2>

          {/* Subtítulo */}
          <p className="font-serif text-lg md:text-xl italic text-[#4A3428]/90 text-center leading-snug max-w-2xl mx-auto mb-14 md:mb-16">
            {t('mercedes.bio_p1')}
          </p>

          {/* La historia */}
          <div className="max-w-3xl mx-auto space-y-6 md:space-y-7">
            <p className="font-serif text-xl md:text-2xl italic text-[#4A3428] leading-snug text-center">
              {t('mercedes.bio_p2')}
            </p>
          </div>

          <div className="max-w-3xl mx-auto mt-6 md:mt-7 space-y-3">
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p3')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p4')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p5')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p6')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p7')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p8')}
            </p>
            <p className="font-serif text-base md:text-lg italic text-[#4A3428] text-center leading-relaxed">
              {t('mercedes.bio_p9')}
            </p>
            <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed">
              {t('mercedes.bio_p10')}
            </p>
            <p className="font-serif text-lg md:text-xl font-semibold text-[#4A3428] text-center leading-snug">
              {t('mercedes.bio_p11')}
            </p>
          </div>

          {/* Fotografías — al final */}
          <div className="mt-14 md:mt-20">
            <h3 className="font-serif text-xl md:text-2xl italic text-[#4A3428] text-center leading-snug max-w-2xl mx-auto mb-8 md:mb-10">
              {t('mercedes.photos_title')}
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
              <figure className="w-60 sm:w-64 md:w-72 flex-shrink-0">
                <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-white/60 border border-[#4A3428]/20">
                  <img
                    src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/33a99cb9-b0d7-4e36-a68e-ed3f6bc992e8_compressed_jcchico.webp"
                    alt="Luisa Victoria junto a su hijo Juan Cruz"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <figcaption className="mt-3 text-center font-sans text-xs text-[#4A3428]/80 leading-snug">
                  {t('mercedes.photo1_caption')}
                </figcaption>
              </figure>
              <figure className="w-60 sm:w-64 md:w-72 flex-shrink-0">
                <div className="relative aspect-[4/5] rounded-2xl overflow-hidden bg-white/60 border border-[#4A3428]/20">
                  <img
                    src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/682e1bce-562c-409b-8d40-7a1718697649_compressed_mickey.webp"
                    alt="Último cumpleaños de Luisa Victoria"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <figcaption className="mt-3 text-center font-sans text-xs text-[#4A3428]/80 leading-snug">
                  {t('mercedes.photo2_caption')}
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-dark-brown">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-10 h-10 flex items-center justify-center text-cream mx-auto mb-6">
            <i className="ri-double-quotes-l text-3xl" />
          </div>
          <p className="font-serif text-lg md:text-xl text-cream leading-relaxed italic mb-6">
            {t('mercedes.quote')}
          </p>
          <p className="font-sans text-sm text-cream">
            {t('mercedes.quote_author')}
          </p>
        </div>
      </section>

      {/* Filosofía Section */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#4A3428] leading-tight mb-12 text-center">
            {t('mercedes.filosofia_title')}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl p-7 md:p-8 border border-sand/30">
                <div className="w-12 h-12 rounded-full bg-terracotta/10 flex items-center justify-center mb-5">
                  <span className="font-serif text-xl font-bold text-terracotta">{i}</span>
                </div>
                <h3 className="font-serif text-lg font-bold text-[#4A3428] mb-3 leading-snug">
                  {t(`mercedes.filosofia_item_${i}_title`)}
                </h3>
                <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                  {t(`mercedes.filosofia_item_${i}_desc`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-sand">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#4A3428] leading-tight mb-4">
            {t('mercedes.cta_title')}
          </h2>
          <p className="font-sans text-sm md:text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('mercedes.cta_desc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/programas"
              className="inline-flex items-center justify-center bg-terracotta text-white px-8 py-4 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap w-full sm:w-auto"
            >
              {t('mercedes.cta_programas')}
              <i className="ri-arrow-right-line ml-2" />
            </Link>
            <Link
              to="/quiero-cambiar"
              className="inline-flex items-center justify-center bg-white border-2 border-[#8B6F5C] text-[#4A3428] px-8 py-4 rounded-full font-sans text-sm font-semibold hover:bg-[#8B6F5C] hover:text-white transition-colors duration-300 whitespace-nowrap w-full sm:w-auto"
            >
              {t('mercedes.cta_gratis')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}